import React from 'react';
import { formatDate } from './CashupUtils';
import moment from 'moment';

/**
 * Component for displaying the "Create today's cash up" row
 * @param {Object} props - Component props
 * @param {Function} props.createTodayCashup - Function to create today's cash up
 */
const TodayCashupRow = ({ createTodayCashup }) => {
  const today = moment().format('YYYY-MM-DD');
  
  return (
    <tr 
      className="cashup-table-row" 
      onClick={createTodayCashup}
      style={{ cursor: 'pointer' }}
    >
      <td>
        <span className="status-badge status-incomplete">Incomplete</span>
      </td>
      <td>
        <span className="clickable-date">
          {formatDate(today)}
        </span>
      </td>
      <td>N/A</td>
      <td>Click to create today's cash up</td>
      <td>N/A</td>
    </tr>
  );
};

export default TodayCashupRow;